import { common } from '@mui/material/colors';

// Default/fallback base color of the system. The actual color in use is held in
// the theme (Redux `theme` slice) so it can be overridden per-user at runtime.
export const BASE_COLOR = '#6A01FE';

export const colors = {
    backgroundColor: '#EFF1FF',
    link: '#1B49EF',
    textError: '#FF0000',
    // Trỏ vào biến CSS động (set bởi AppThemeProvider) để mọi chỗ dùng
    // colors.main tự đổi theo màu của từng user tại runtime.
    main: 'var(--color-primary)',
};

export const regexEmail =
    /^(?!.*\.\.)(?!.*\.@)[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;

export const regexPassword =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&#])[\w@$!%*?&#]{6,}$/;

export const phoneRegExp = /^0(?:3[2-9]|5[2689]|7[06-9]|8[1-5]|9[0-9])\d{7}$/;

export enum ErrorCodes {
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    INVALID_EXCHANGE_REQUEST = 1401,
    SURVEY_INVALID = 2100,
    SURVEY_ANSWERED_ERROR = 2101,
    SURVEY_CODE_INVALID = 2102,
    SURVEY_KEY_INVALID = 2103,
    SURVEY_NOT_MACTH = 2104,
    VERSION_NOT_MATCH = 2105,
    ANSWER_CREATE_FAIL = 3001,
    UPLOAD_IMAGE_INVALID_FILE_TYPE = 3100,
    UPLOAD_IMAGE_MAX_SIZE = 3101,
    UPLOAD_IMAGE_FAILED = 3102,
    DELETE_IMAGE_FAILED = 3103,
    LOGIN_FAIL = 3104,
    REGISTRATION_ERROR = 3105,
    ACCOUNT_NOT_FOUND = 3106,
    CONFIRM_EMAIL = 3107,
    EMAIL_ERROR = 3108,
    CONFIRM_EMAIL_ERROR_EMAIL_NOT_FOUND = 3110,
    CONFIRM_EMAIL_ERROR_EMAIL_CONFIRMED = 3111,
    CONFIRM_EMAIL_ERROR_TOKEN_INVALID = 3112,
    ACCOUNT_LOCKED = 3117,
}

export const TOKEN_KEY = 'access_token';

export const FORMAT = {
    date: {
        DMY: 'DD/MM/YYYY',
    },
};

export const styleInput = {
    '& .MuiInputBase-root': {
        height: '60px',
        borderRadius: '33px',
        background: common.white,
        fontSize: '20px',
        fontWeight: '400',
        padding: '30px 18px 30px 18px',
    },
};

export const styleCheckbox = {
    '& .MuiCheckbox-root': {
        color: common.white,
        '&.Mui-checked': {
            color: 'rgba(255, 255, 255, 1)',
        },
    },
};

export const styleSelect = {
    '& .MuiInputBase-root': {
        height: '60px',
        borderRadius: '33px',
        background: common.white,
        fontSize: '20px',
        fontWeight: '400',
        padding: '30px 18px 30px 18px',
    },
};

export const headerFilterCampaignId = 'main-header-campaign-filter';

export const urlGuideUpload = `${process.env.REACT_APP_URL_S3}public/Hu%CC%9Bo%CC%9B%CC%81ng%20da%CC%82%CC%83n%20upload%20File%20ma%CC%82%CC%83u.docx`;
export const urlExportQuestionTemplate = `${process.env.REACT_APP_URL_S3}public/question_template_20241015.xlsx`;

export enum ZIndex {
    Overlay = 9999,
}

export const styleInputNumber = {
    '& .MuiInputBase-root': {
        padding: 0,
        maxWidth: '110px',
        maxHeight: '24px',
        background: common.white,
        color: common.black,
        border: `1px solid ${common.black}`,
        '& input': {
            padding: 0,
            textAlign: 'center',
        },
        '& fieldset': {
            border: 'none',
        },
        '& .MuiInputAdornment-root:first-of-type button': {
            padding: 0,
            borderRadius: 0,
            borderRight: `1px solid ${common.black}`,
        },
        '& .MuiInputAdornment-root:last-of-type button': {
            padding: 0,
            borderRadius: 0,
            borderLeft: `1px solid ${common.black}`,
        },
    },
};

export const styleInputNumberMedium = {
    '& .MuiInputBase-root': {
        padding: 0,
        maxWidth: '220px',
        maxHeight: '24px',
        background: common.white,
        color: common.black,
        border: `1px solid ${common.black}`,
        '& input': {
            padding: 0,
            textAlign: 'center',
        },
        '& fieldset': {
            border: 'none',
        },
        '& .MuiInputAdornment-root:first-of-type button': {
            padding: 0,
            borderRadius: 0,
            borderRight: `1px solid ${common.black}`,
        },
        '& .MuiInputAdornment-root:last-of-type button': {
            padding: 0,
            borderRadius: 0,
            borderLeft: `1px solid ${common.black}`,
        },
    },
};

export enum Role {
    SUPER = 'super',
    CLIENT = 'client',
    SALES = 'sales',
    ACCOUNTANT = 'accountant',
}

export const demoUserId = Number(process.env.REACT_APP_DEMO_USER_ID);
